import React from 'react';
import { Form, Field } from 'react-final-form';
import MakeAsyncFunction from 'react-redux-promise-listener';
import validations from './validations';
import InputField from 'src/components/InputField';
import CheckboxField from 'src/components/CheckboxField';
import SelectField from 'src/components/SelectField';
import { promiseListener } from 'src/store';

const userPermissions = [{
    value: 'SELLER',
    text: 'Vendedor',
}, {
    value: 'ADMIN',
    text: 'Admininstrador'
}, {
    value: 'SUPERVISOR',
    text: 'Supervisor'
}];

const optionsPermission = userPermissions.map(permission =>
    <option key={permission.value} value={permission.value}>{permission.text}</option>
);

const Condition = ({ when, children }) => {
    if (when) {
        return children;
    }
    return null;
}

const FormBody = ({ handleSubmit, type, userExists }) => (
    <form onSubmit={handleSubmit}>                        
        <div className="pl-lg-4">
            <div className="row">
                <div className="col-12 col-md-6">
                    <Field
                        name="user.document"
                        type="text"
                        className="form-control"
                        label="CPF/CNPJ"
                        component={InputField}
                    />
                </div>
                <div className="col-12 col-md-6">
                    <button type="submit" className="btn btn-success mt-4">Procurar</button>
                </div>
            </div>
            <Condition when={userExists}>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <Field
                            name="user.name"
                            type="text"
                            className="form-control"
                            label="Nome"
                            component={InputField}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <Field
                            name="user.phone"
                            type="text"
                            className="form-control"
                            label="Telefone"
                            component={InputField}
                        />
                    </div>
                    <div className="col-12 col-md-6">
                        <Field
                            name="user.email"
                            type="email"
                            className="form-control"
                            label="Email"
                            component={InputField}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <Field
                            name="permission"
                            type="text"
                            className="form-control"
                            label="Função"
                            options={optionsPermission}
                            component={SelectField}
                        />
                    </div>
                </div>
                { (type === 'edit') &&
                    <div className="form-group">
                            <Field
                                name="isActive"
                                type="checkbox"
                                className="form-control"
                                label="Ativação"
                                text="Ativado"
                                component={CheckboxField}
                            />  
                        </div>
                }
            </Condition>
        </div>
        <div className="text-center">
            <button type="submit" className="btn btn-success mt-4">Salvar</button>
        </div>
    </form>
);

const UserForm = ({ type, actions }) => (
    <MakeAsyncFunction
        listener={promiseListener}
        {...actions}
        >{submit => (
            <Form
                onSubmit={submit}
                // validate={validations}
                render={(props) => ( <FormBody {...props} userExists={false} />)}
            />
        )}
    </MakeAsyncFunction>
);

export default UserForm;


// WEBPACK FOOTER //
// ./src/components/Pages/Users/Management/Form.js